// iOS 26 Safari / PWA：聚焦输入框再收起键盘后，visualViewport.offsetTop 不会归零，
// position: fixed 的顶栏 / 底栏就会相对屏幕错位（顶栏压到状态栏、底栏被抬高），
// 只有完全关掉 Safari / PWA 重开才恢复。这是 WebKit 的 bug，页面代码无法根治，这里做补偿：
//   没有在输入、页面没被缩放时，若 offsetTop 不为 0，就把它写进 CSS 变量，
//   让 .header / .tab-bar / .maint-admin-pill 反向偏移，视觉上回到正确位置。
//   --vv-top    顶栏向下挪的距离
//   --vv-bottom 底栏向下挪的距离
// 正常情况下两个变量都是 0，等于什么都没做。

const NON_TEXT_INPUT = ['checkbox', 'radio', 'button', 'submit', 'reset', 'file', 'range', 'color', 'image'];

function isEditing() {
  const el = document.activeElement;
  if (!el) return false;
  const tag = el.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') return !NON_TEXT_INPUT.includes((el.type || '').toLowerCase());
  return !!el.isContentEditable;
}

export function installViewportFix() {
  const vv = window.visualViewport;
  if (!vv || typeof document === 'undefined') return;

  const root = document.documentElement;
  let cur = { top: 0, bottom: 0 };
  let timer = null;

  const apply = (top, bottom) => {
    if (top === cur.top && bottom === cur.bottom) return;
    cur = { top, bottom };
    root.style.setProperty('--vv-top', top + 'px');
    root.style.setProperty('--vv-bottom', bottom + 'px');
  };

  const read = () => {
    timer = null;
    const top = vv.offsetTop;
    // 输入中（键盘本来就会顶起视口）、或页面被缩放：不补偿
    if (isEditing() || Math.abs(vv.scale - 1) > 0.01 || top < 0.5 || top > 120) {
      apply(0, 0);
    } else {
      const bottom = Math.min(Math.max(top + vv.height - window.innerHeight, 0), top);
      apply(Math.round(top), Math.round(bottom));
    }
  };

  // offsetTop 回到 0 时立刻复位；非 0 时等 120ms 稳定后再补偿，避免橡皮筋回弹等瞬时抖动被当成错位
  const onChange = () => {
    if (vv.offsetTop < 0.5) {
      if (timer) { clearTimeout(timer); timer = null; }
      read();
      return;
    }
    if (timer) clearTimeout(timer);
    timer = setTimeout(read, 120);
  };

  vv.addEventListener('resize', onChange);
  vv.addEventListener('scroll', onChange);
  // 键盘收起动画约 300ms，收完再校准一次
  window.addEventListener('focusout', () => setTimeout(onChange, 350));
  window.addEventListener('orientationchange', () => setTimeout(onChange, 350));
  window.addEventListener('pageshow', onChange);
  // 页面切换（App.js 的 RouteScrollReset 派发）：先把补偿值清零，等切页后的布局稳定再按实际的 offsetTop 重新校准。
  // 不清零的话，上一页留下的 --vv-top 会带到新页面，顶栏被推到错误的位置。
  window.addEventListener('app:route-change', () => {
    if (timer) { clearTimeout(timer); timer = null; }
    apply(0, 0);
    setTimeout(onChange, 350);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') onChange();
  });

  onChange();
}
